export default "__VITE_ASSET__E8KmhFXP__"